/// <amd-module name="Build/Designer/LoseChangesDialog" />
import * as React from "react";

import * as Resources from "Build/Designer/Resources";

import { Dialog } from "VSSUI/Dialog";

import { FastPageSwitchEventDetail, IVssPageContext } from "VSS/Platform/Context";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { IVssLayoutManager } from "VSS/Platform/Layout";

/**
 * Add listeners for before navigating away from a FastPageSwitch or BeforeUnloadEvent event.
 */
export function addNavigateAwayListener(onNavigateAway: (ev: BeforeUnloadEvent | CustomEvent) => void) {
    document.body.addEventListener("fpsStarting", onNavigateAway);
    window.addEventListener("beforeunload", onNavigateAway);
}

/**
 * Remove listeners for before navigating away from a FastPageSwitch or BeforeUnloadEvent event.
 */
export function removeNavigateAwayListener(onNavigateAway: (ev: BeforeUnloadEvent | CustomEvent) => void) {
    document.body.removeEventListener("fpsStarting", onNavigateAway);
    window.removeEventListener("beforeunload", onNavigateAway);
}

/**
 * Show a confirmation dialog before navigating away from a FastPageSwitch or BeforeUnloadEvent event.
 */
export function showLoseChangesDialog(pageContext: IVssPageContext, ev: BeforeUnloadEvent | CustomEvent) {

    // Handle cases of Fast Page Switching
    const fpsDetail = (ev as CustomEvent).detail as FastPageSwitchEventDetail;
    if (fpsDetail && fpsDetail.href) {

        if (fpsDetail.data && fpsDetail.data.isPageSwitchConfirmed) {
            return;
        }

        ev.preventDefault();
        const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout((onDismiss) => {
            const leave = () => {
                onDismiss();
                fpsDetail.data = fpsDetail.data || {};
                fpsDetail.data.isPageSwitchConfirmed = true;
                FastPageSwitch(fpsDetail.pageContext, fpsDetail.href, fpsDetail.recordHistoryEntry, fpsDetail.data);
            };
            const stay = () => { onDismiss() };
            return getLoseChangesDialog(leave, stay);
        });
    }
    else {
        // Handle cases of general browser BeforeUnloadEvent
        ev.returnValue = Resources.ConfirmLosingUnsavedChange;
    }
}

export function getLoseChangesDialog(leave: () => void, stay: () => void): JSX.Element {
    return <Dialog
        titleProps={{ text: Resources.ConfirmLosingUnsavedChangeTitle }}
        onDismiss={stay}
        footerButtonProps={[ { primary: true, onClick: leave, text: Resources.Leave }, { onClick: stay, text: Resources.Stay } ]}
        lightDismiss={false}>
        {Resources.ConfirmLosingUnsavedChange}
    </Dialog>;
}
